import {useEffect, useMemo, useRef} from 'react'
import styles from './SmartTextArea.module.scss'
import TextWithCursor from './TextWithCursor'
import {useDirection} from './useDirection'
import classes from 'classnames'

export default function ChatRenderer({ chat }) {

  const bottomRef = useRef(null)
  const lastAssistantIndex = useMemo(() => {
    return chat.reduce((lastIndex, { role }, index) => {
      return role === 'assistant' ? index : lastIndex;
    }, -1);
  }, [chat])

  const last = chat[chat.length - 1]
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: 'nearest', behavior: 'auto' })
  }, [chat.length, last?.text])


  // cursor should be shown only for the last assistant message
  return (
    <div className={styles.chatRenderer}>
      {chat.map(({role, text, topN, selectedTopNIndex, isTopNPanelOpen}, index) =>
        <SingleChatParticle key={index}
                            text={text}
                            topN={topN}
                            selectedTopNIndex={selectedTopNIndex}
                            isTopNPanelOpen={isTopNPanelOpen}
                            isWithCursorAndTopN={index === lastAssistantIndex}/>)}
      <div ref={bottomRef} />
    </div>
  )
}

function SingleChatParticle({ isWithCursorAndTopN, text, topN, selectedTopNIndex, isTopNPanelOpen }) {
  const dir = useDirection(text)

  return (
    <div className={classes(
      { [styles.particleContainerRtl]: dir === 'rtl'},
      { [styles.particleContainerLtr]: dir === 'ltr'},
    )}
    >
      <TextWithCursor
        text={text}
        isWithCursorAndTopN={isWithCursorAndTopN}
        topN={topN}
        selectedTopNIndex={selectedTopNIndex}
        isTopNPanelOpen={isTopNPanelOpen}
        className={styles.charsContainer}
      />
    </div>
  );
}
